<template>
  <v-layout align-center justify-center>
    <v-flex xs11 sm8 md6>
      <v-card class="elevation-12">
        <v-toolbar dark class="gradient">
          <slot name="header"></slot>
        </v-toolbar>
        <v-card-text>
          <slot name="body"></slot>
        </v-card-text>
        <v-card-actions>
          <slot name="footer"></slot>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'card'
  }
</script>

<style scoped>
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Card.vue